import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const ContextualHelpLauncher = ({ isOpen, onToggle }) => {
  const tooltips = [
    {
      id: 1,
      title: 'Compliance Score Interpretation',
      description: 'Learn how to interpret your compliance score and identify areas for improvement',
      action: 'View Guide'
    },
    {
      id: 2,
      title: 'NASFUND Filing Deadline',
      description: 'Upcoming NASFUND contribution filing deadline in 7 days',
      action: 'Set Reminder'
    },
    {
      id: 3,
      title: 'SWT Calculation Help',
      description: 'Need help with Salary & Wages Tax calculations? View our step-by-step guide',
      action: 'Start Tutorial'
    }
  ];

  return (
    <>
      {/* Floating Action Button */}
      <button
        onClick={onToggle}
        className="fixed bottom-6 right-6 bg-primary text-primary-foreground p-4 rounded-full shadow-lg hover:shadow-xl transition-smooth hover:scale-110 z-50"
        aria-label="Toggle contextual help"
      >
        <Icon name={isOpen ? 'X' : 'HelpCircle'} size={24} color="currentColor" />
      </button>

      {/* Contextual Help Panel */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 w-96 bg-card border border-border rounded-lg shadow-xl z-50 overflow-hidden">
          <div className="bg-primary text-primary-foreground p-4">
            <h3 className="text-lg font-heading font-semibold flex items-center gap-2">
              <Icon name="Lightbulb" size={20} color="currentColor" />
              Contextual Help
            </h3>
            <p className="text-sm opacity-90 mt-1">
              Quick tips and guidance for your current screen
            </p>
          </div>

          <div className="p-4 space-y-3 max-h-96 overflow-y-auto">
            {tooltips?.map((tooltip) => (
              <div key={tooltip?.id} className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-smooth">
                <h4 className="font-semibold text-foreground text-sm mb-2">
                  {tooltip?.title}
                </h4>
                <p className="text-xs text-muted-foreground mb-3">
                  {tooltip?.description}
                </p>
                <Button size="sm" variant="outline" fullWidth>
                  {tooltip?.action}
                </Button>
              </div>
            ))}
          </div>

          <div className="border-t border-border p-4">
            <Button 
              fullWidth 
              variant="ghost" 
              iconName="BookOpen"
              onClick={() => window.location.href = '/in-app-help-center'}
            >
              View All Help Topics
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ContextualHelpLauncher;